export const buildVCard = (agent) =>
  [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${agent.lastName};${agent.firstName};;;`,
    `FN:${agent.firstName} ${agent.lastName}`,
    "ORG:Pimp My Place",
    `TITLE:${agent.role}`,
    `TEL;TYPE=CELL,VOICE:${agent.phone}`,
    `EMAIL;TYPE=WORK,INTERNET:${agent.email}`,
    `URL:https://${agent.website}`,
    `NOTE:${agent.tagline}`,
    "END:VCARD",
  ].join("\r\n");

export const downloadVCard = (content, filename) => {
  const blob = new Blob([content], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
